import SummaryDisplay from './SummaryDisplay';

export default SummaryDisplay;
